import { useLanguage } from "@/i18n/LanguageContext";

export function AudioVisualizer({ currentAudioLevel, gateThreshold, isGateOpen }) {
  const { t } = useLanguage();
  
  // Convert dB to percentage (0-100) for visualization
  // -60dB = 0%, 0dB = 100%
  const levelPercent = ((currentAudioLevel + 60) / 60) * 100;
  const thresholdPercent = ((gateThreshold + 60) / 60) * 100;
  
  return (
    <div className="space-y-4" data-testid="audio-visualizer">
      {/* Level meter */}
      <div className="relative h-8 bg-zinc-900 rounded-lg overflow-hidden">
        {/* Threshold line */}
        <div 
          className="absolute top-0 bottom-0 w-0.5 bg-yellow-500 z-10"
          style={{ left: `${thresholdPercent}%` }}
          title={`Gate: ${gateThreshold}dB`}
        />
        {/* Level bar */}
        <div 
          className={`h-full transition-all duration-75 ${isGateOpen ? 'bg-green-500' : 'bg-red-500/50'}`}
          style={{ width: `${Math.max(0, levelPercent)}%` }}
        />
        {/* Labels */}
        <div className="absolute inset-0 flex items-center justify-between px-2 text-xs text-white/70">
          <span>-60dB</span>
          <span className={`font-mono ${isGateOpen ? 'text-green-400' : 'text-red-400'}`}>
            {currentAudioLevel.toFixed(1)}dB
          </span>
          <span>0dB</span>
        </div>
      </div>
      
      {/* Gate status */}
      <div className="flex items-center justify-center gap-2">
        <div className={`w-3 h-3 rounded-full ${isGateOpen ? 'bg-green-500 animate-pulse' : 'bg-zinc-600'}`} />
        <span className={`text-sm ${isGateOpen ? 'text-green-400' : 'text-zinc-500'}`}>
          {isGateOpen ? t("gateOpen") : t("gateClosed")}
        </span>
      </div>
    </div>
  );
}
